import { ComponentOutput, SceneComponent } from '../SceneComponent';
import { LineSegmentsGeometry } from 'three/examples/jsm/lines/LineSegmentsGeometry';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial';

const defaultInputs: Inputs = {
  depth: 1,
  width: 1,
  height: 1,
  color: 0xffffff,
  opacity: 1.0,
  visible: true,
}

type Inputs = {
  depth: number;
  width: number;
  height: number;
  color: number;
  opacity: number;
  visible: boolean;
}

type Outputs = {
  self: SceneComponent|null;
} & ComponentOutput;


interface IDisposable {
  dispose(): void;
}

class Box extends SceneComponent {
  private disposable: IDisposable|null = null;
  
  inputs: Inputs = {
    ...defaultInputs,
  }

  outputs = {
    self: null,
  } as Outputs;

  constructor() {
    super();
    this.outputs.self = this;
  }

  onInit() {
    const THREE = this.context.three;
    this.outputs.objectRoot = new THREE.Object3D();

    this.buildBox();
  }

  onInputsUpdated() {
    this.buildBox();
  }

  buildBox() {
    this.releaseResources();

    const iframe = document.getElementById('sdk-iframe') as HTMLIFrameElement;
    const height = iframe.contentWindow.innerHeight;
    const width = iframe.contentWindow.innerWidth;

    const THREE = this.context.three;
    const geometry = new THREE.BoxGeometry( this.inputs.width, this.inputs.height, this.inputs.depth );
    const material = new THREE.MeshBasicMaterial( {color: this.inputs.color } );
    if (this.inputs.opacity < 1) {
      material.transparent = true;
      material.opacity = this.inputs.opacity;
      material.depthWrite = false;
    }
    const mesh = new THREE.Mesh( geometry, material );
    mesh.layers.set(31);
    this.outputs.objectRoot.add(mesh);


    const edges = new THREE.EdgesGeometry(mesh.geometry, 20);
    const geo = (new (THREE as any).LineSegmentsGeometry() as LineSegmentsGeometry).fromEdgesGeometry(edges);

    const lineMaterial = new (THREE as any).LineMaterial({
      side: THREE.DoubleSide,
      color: 0x999999,
      transparent: true,
      opacity: 0.3,
      depthWrite: false,
      // clippingPlanes: clippingPlanes,
      dashed: false,
      linewidth: 2,
    }) as LineMaterial;
    lineMaterial.resolution.set(width, height);
  
    const wireframe = new (THREE as any).Wireframe(geo, lineMaterial);
    wireframe.computeLineDistances();
    wireframe.scale.set(1, 1, 1);

    // const edges = new THREE.EdgesGeometry( geometry );
    // const lineMaterial = new THREE.LineBasicMaterial( { color: this.inputs.color } );
    // const line = new THREE.LineSegments( edges, lineMaterial);
    wireframe.layers.set(31);
    this.outputs.objectRoot.add(wireframe);
    this.outputs.objectRoot.visible = this.inputs.visible;

    this.disposable = {
      dispose: () => {
        material.dispose();
        geometry.dispose();
        lineMaterial.dispose();
        edges.dispose();
        this.outputs.objectRoot.remove(mesh, wireframe);
      }
    }
  }

  onDestroy() {
    this.releaseResources();
  }

  private releaseResources() {
    if (this.disposable) {
      this.disposable.dispose();
      this.disposable = null;
    }
  }
}

export const boxType = 'mp.box';
export const makeBox = function() {
  return new Box();
}
